import { useIntl } from 'react-intl';
import { StyledEditClassifiers } from './style';
import { Button, Drawer, Icon, Spinner, Input } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import RichTextInput from 'ui/Input/ReactQuillInput';
import Form, { useForm } from 'antd/es/form/Form';
import { Classifier } from 'types/Classifier';
import { StyledFooter } from 'ui/Drawer/Drawers/style';

interface EditClassifiersProps {
  classifierIdToEdit: number | undefined;
  setReload: React.Dispatch<React.SetStateAction<number>>;
  isDrawerOpen: boolean;
  closeDrawer: () => void;
}

const EditClassifiers = ({
  classifierIdToEdit,
  setReload,
  isDrawerOpen,
  closeDrawer,
}: EditClassifiersProps) => {
  const intl = useIntl();
  const [form] = useForm();

  const { isLoading: isClassifierSaving, appendData: saveClassifier } =
    useQueryApiClient({
      request: {
        url: `/api/v2/classifiers/${classifierIdToEdit}`,
        method: 'PATCH',
      },
      onSuccess: () => {
        setReload((old) => old + 1);
        closeDrawer();
      },
    });

  const { isLoading: isClassifierLoading } = useQueryApiClient({
    request: {
      url: `/api/v2/classifiers/${classifierIdToEdit}`,
      disableOnMount: !classifierIdToEdit,
    },
    onSuccess: (response) => {
      handleClassifierData(response);
    },
  });

  const handleClassifierData = (classifier: Classifier) => {
    Object.entries(classifier).forEach(([key, value]) => {
      form.setFieldValue(key, value);
    });
  };

  const Footer = () => (
    <StyledFooter>
      <Button
        className={'add-edit-product-button white'}
        label={intl.formatMessage({ id: 'general.cancel' })}
        onClick={() => {
          closeDrawer();
        }}
      />
      <Button
        className={'add-edit-product-button black'}
        label={intl.formatMessage({ id: 'general.save' })}
        onClick={() => form.submit()}
      />
    </StyledFooter>
  );

  return (
    <Drawer
      open={isDrawerOpen}
      title={intl.formatMessage({
        id: `classifiers.contract_information_drawer_edit_title`,
      })}
      onClose={closeDrawer}
      destroyOnClose
      maskClosable
      width={'50%'}
      footer={<Footer />}
      closeIcon={<Icon name={'global-close-icon'} type={'small'} />}
    >
      <StyledEditClassifiers>
        <Spinner spinning={isClassifierLoading || isClassifierSaving}>
          <Form form={form} layout={'vertical'} onFinish={saveClassifier}>
            <Input
              name={'name'}
              label={intl.formatMessage({ id: 'general.name' })}
              disabled
            />
            <RichTextInput name={'value'} />
          </Form>
        </Spinner>
      </StyledEditClassifiers>
    </Drawer>
  );
};

export default EditClassifiers;
